"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.startApp = void 0;

var _ActionTypes = require("./ActionTypes");

var _params = require("../utils/params");

var startApp = function startApp() {
  return function (dispatch) {
    dispatch({
      type: _ActionTypes.APP_STARTED,
      payload: {
        trackingParams: (0, _params.getParsedTrackingParams)()
      }
    });
  };
};

exports.startApp = startApp;


//////////////////
// WEBPACK FOOTER
// ./js/actions/AppActions.js
// module id = 645
// module chunks = 209 210 211 212